import type { Agent } from '@studio/models/agent';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Video } from '../video/video.jsx';

/** Props for VideoContent component */
interface VideoContentProps {
  agent?: Agent | undefined;
  className?: string;
}

/**
 * VideoContent component for Iris Connection video settings
 *
 * Displays video stream configuration, quality settings, and preview
 * for the Iris camera connection.
 */
export const VideoContent = ({ className }: VideoContentProps): ReactElement => {
  return (
    <div className={twMerge('flex flex-col gap-24', className)}>
      <div className='flex flex-col gap-16'>
        <Video className='w-full' />
      </div>
    </div>
  );
};

VideoContent.displayName = 'VideoContent';
